import React, { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { abTestState, pageContextState } from '../../recoil/atoms';
import { PageContext } from '../../enums/PageContext.enum';
import ColorSwatch from './ColorSwatch';
import { Color } from '../../enums/Color.enum';
import styles from './ColorSwatches.module.scss';
import classnames from 'classnames';
import { SelectionType } from '../../enums/SelectionType.enum';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { useProductSelection } from '../../hooks/useProductSelection';

interface Props {
  colors: Color[];
  activeColor: Color | undefined;
  activate: (color: Color | undefined) => void;
  showAllSwatch?: boolean;
  label1?: boolean;
  label2?: boolean;
  singleOption?: boolean;
  styleOverrides?: {
    container?: React.CSSProperties;
    swatches?: React.CSSProperties;
    title?: React.CSSProperties;
  };
}

export const ColorSwatches: React.FC<Props> = ({ colors, activeColor, activate, label1, label2, singleOption, showAllSwatch, styleOverrides }) => {
  return (
    <div className={styles.colorSwatchContainer} style={{ ...styleOverrides?.container }}>
      <div className={classnames(styles.swatchTitle, { [styles.hidden]: !label1 && !singleOption })} style={{ ...styleOverrides?.title }}>
        COLOR: <span>{activeColor?.replace(' And ', ' & ')}</span>
      </div>
      <div className={classnames(styles.colorSwatchTitle, { [styles.hidden]: !label2 })}>
        <span style={{ fontWeight: 600, textTransform: 'uppercase' }}>Colors</span> | {activeColor}
      </div>
      {!singleOption && (
        <div className={styles.colorSwatches} style={{ ...styleOverrides?.swatches }}>
          {showAllSwatch && <ColorSwatch key={'all'} color={undefined} active={activeColor === undefined} activate={activate} />}
          {colors
            .filter((color) => Object.values(Color).includes(color))
            .map((color) => (
              <ColorSwatch key={color} color={color} active={color === activeColor} activate={activate} />
            ))}
        </div>
      )}
    </div>
  );
};

export default ColorSwatches;
